import _ from 'lodash'

export const SECTIONS_OPTIONAL_TOOLBAR_OPTIONS = {
    color: {
        rows: [['color', 'background']],
        insertAfter: row => row.includes('bold'),
    },
    indent: {
        rows: [[{ indent: '-1' }, { indent: '+1' }]],
        insertAfter: row => row.some(item => _.get(item, 'list') === 'ordered'),
    },
    script: {
        rows: [[{ script: 'sub' }, { script: 'super' }]],
        insertBefore: row => row.includes('link'),
    },
    blockquote: {
        rows: [['blockquote']],
        insertBefore: row => row.includes('link'),
    },
}

export function buildSectionsQuillToolbar(baseContainer, enabledOptionKeys = []) {
    const container = _.cloneDeep(baseContainer)

    Object.keys(SECTIONS_OPTIONAL_TOOLBAR_OPTIONS).forEach(key => {
        if (!enabledOptionKeys.includes(key)) return

        const option = SECTIONS_OPTIONAL_TOOLBAR_OPTIONS[key]
        let index = container.length

        if (option.insertAfter) {
            const anchorIndex = container.findIndex(option.insertAfter)
            if (anchorIndex >= 0) index = anchorIndex + 1
        } else if (option.insertBefore) {
            const anchorIndex = container.findIndex(option.insertBefore)
            if (anchorIndex >= 0) index = anchorIndex
        }

        container.splice(index, 0, ...option.rows)
    })

    return container
}
